import Col from "./Col";
import Row from "./Row";
import Cell from "./Cell";

export default {
  col: Col,
  row: Row,
  cell: Cell,
};
